export const GET_SCOPE_YEARS_REQUEST = "GET_SCOPE_YEARS_REQUEST";
export const GET_SCOPE_YEARS_SUCCESS = "GET_SCOPE_YEARS_SUCCESS";
export const GET_SCOPE_YEARS_FAIL = "GET_SCOPE_YEARS_FAIL";

export const GET_EXCHANGE_SYSTEMS_REQUEST = "GET_EXCHANGE_SYSTEMS_REQUEST";
export const GET_EXCHANGE_SYSTEMS_SUCCESS = "GET_EXCHANGE_SYSTEMS_SUCCESS";
export const GET_EXCHANGE_SYSTEMS_FAIL = "GET_EXCHANGE_SYSTEMS_FAIL";

export const GET_REGION_REQUEST = "GET_REGION_REQUEST";
export const GET_REGION_SUCCESS = "GET_REGION_SUCCESS";
export const GET_REGION_FAIL = "GET_REGION_FAIL";

export const GET_SITES_REQUEST = "GET_SITES_REQUEST";
export const GET_SITES_SUCCESS = "GET_SITES_SUCCESS";
export const GET_SITES_FAIL = "GET_SITES_FAIL";

export const GET_ACTIVITIES_REQUEST = "GET_ACTIVITIES_REQUEST";
export const GET_ACTIVITIES_SUCCESS = "GET_ACTIVITIES_SUCCESS";
export const GET_ACTIVITIES_FAIL = "GET_ACTIVITIES_FAIL";

export const GET_FIELD_TASKS_REQUEST = "GET_FIELD_TASKS_REQUEST";
export const GET_FIELD_TASKS_SUCCESS = "GET_FIELD_TASKS_SUCCESS";
export const GET_FIELD_TASKS_FAIL = "GET_FIELD_TASKS_FAIL";

export const GET_FORECASTS_REQUEST = "GET_FORECASTS_REQUEST";
export const GET_FORECASTS_SUCCESS = "GET_FORECASTS_SUCCESS";
export const GET_FORECASTS_FAIL = "GET_FORECASTS_FAIL";

export const GET_BTS_REQUEST = "GET_BTS_REQUEST";
export const GET_BTS_SUCCESS = "GET_BTS_SUCCESS";
export const GET_BTS_FAIL = "GET_BTS_FAIL";

export const GET_CONTRACTS_REQUEST = "GET_CONTRACTS_REQUEST";
export const GET_CONTRACTS_SUCCESS = "GET_CONTRACTS_SUCCESS";
export const GET_CONTRACTS_FAIL = "GET_CONTRACTS_FAIL";

export const GET_PERMITS_REQUEST = "GET_PERMITS_REQUEST";
export const GET_PERMITS_SUCCESS = "GET_PERMITS_SUCCESS";
export const GET_PERMITS_FAIL = "GET_PERMITS_FAIL";

export const GET_INVOICES_REQUEST = "GET_INVOICES_REQUEST";
export const GET_INVOICES_SUCCESS = "GET_INVOICES_SUCCESS";
export const GET_INVOICES_FAIL = "GET_INVOICES_FAIL";

export const LOAD_DATA_REQUEST = "LOAD_DATA_REQUEST";
export const LOAD_DATA_SUCCESS = "LOAD_DATA_SUCCESS";
export const LOAD_DATA_FAIL = "LOAD_DATA_FAIL";
